module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABQElEQVQ4T63TvUrDYBSA4fckKqLUVbwHwQvoHfQKTOlfrNpJtIO4qjgJDoIgdekfWB10EdRKxdsQB3HV0YKgph7pUNDwpV8EMyfPOW++RPinS0xOpqlzvYCkKNfHC/IYZ5YR8mp6jpIC7ggotJbk2YYZoXRDs9rjAJhC6PBJxoYZof50r66LKNsoMwI3CqstX+6jNouElis62h0nzxd7wKTArQbkojaLhAaTvaquADu2TCsUNzMWFM4EKokP1o9K8jbYPDb0OkZRYBeYEOGw+87GxZ8gVZmvURLYBKYFLnsO5dO8PPw8weEbqUq6zpoqW0BChCvXodDMyUv4Mxh6/L9yoO26+Cakj5ohQ86IQ7kRyrGmeTX1UfZtOVYoXdUzhZQIHdehGJVjhbINnQ0Ckiq0T3x5sv350e8ozpOhe74BJnyDE2ZKy+UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/icon-right-blue.png
// module id = W6LE
// module chunks = 4